export class SenderId {

    constructor(
        public originationId: string,
        public countryCode: string
    ) { }
}
